<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('customer')">
                        <div class="label-as-input">{{ isNotNullValue(formData.name) + ' ' + isNotNullValue(formData.surname) }}</div>
                    </b-form-group>
                </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('amount')">
                        <div class="label-as-input">{{ isNotNullValue(formData.amount) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('currency')">
                        <div class="label-as-input">{{ isNotNullValue(formData.currency) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('refund_date')">
                        <div class="label-as-input">{{ isNotNullValue(formData.date) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('reason')">
                        <div class="label-as-input">{{  getLocaleText(formData, 'reason_name')}}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group class="col-12" :label="$t('explanation')">
                        <div class="label-as-input">{{ isNotNullValue(formData.explanation) }}</div>
                    </b-form-group>
                </b-col>

            </b-row>

        </ValidationObserver>
    </div>
</template>

<script>
    import CustomerRefundService from "@/services/CustomerRefundService";

    export default {
        components: {
          CustomerRefundService
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {}

            }
        },

        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                CustomerRefundService.get(id)
                             .then((response) => {
                                 this.formData = response.data.data;
                                 this.formLoading = false;
                             })
                             .catch((error) => {
                                 if (error.data.message) {
                                     this.$toast.error(this.$t("api." + error.data.message));
                                 }
                             });
            },
        }
    }
</script>
